// extracted by mini-css-extract-plugin
module.exports = {"BottomContainer":"Frequency_BottomContainer__2mzCx","ComponentHeader":"Frequency_ComponentHeader__3mvgf","HeaderLeft":"Frequency_HeaderLeft__3zE2p"};